import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient';
import { useInfiniteQuery } from '@tanstack/react-query';
export const useMembersInfiniteQuery = (searchQuery) => {
    const limit = 10;
    const membersInfiniteQuery = useInfiniteQuery({
        queryKey: ['membersInfinite', searchQuery],
        queryFn: async ({ pageParam = 1 }) => {
            const { data } = await MembershipsCreatorApiClient.getMembers({
                limit,
                page: pageParam,
                search_query: searchQuery,
            });
            return data;
        },
        enabled: !!(searchQuery && searchQuery.length > 2),
        getNextPageParam: ({ pagination }) => {
            if (pagination?.pages === pagination?.page)
                return;
            return pagination && pagination.page + 1;
        },
    });
    return { membersInfiniteQuery };
};
